import { walletManager } from '../utils/walletManager';

export default {
  install(Vue) {
    // 初始化钱包管理器
    walletManager.init();
    
    // 添加到Vue原型
    Vue.prototype.$wallet = walletManager;
    
    // 添加全局方法
    Vue.$wallet = walletManager;
  }
};